import $ from 'jquery'
import Isotope from 'isotope-layout'
import { debounce } from '../functions'

const wrapper = $('.solutions-isotope')

if (wrapper.length) {
  let iso
  let qsRegex
  window.addEventListener('load', () => {
    iso = new Isotope(wrapper[0], {
      itemSelector: '.solutions-isotope-item',
      percentPosition: true,
      masonry: {
        columnWidth: '.solutions-isotope--sizer',
      },
    })
  })

  const search = $('.solutions-isotope-item .search-field').keyup(
    debounce(function () {
      qsRegex = new RegExp(search.val(), 'gi')

      iso.arrange({
        filter: function () {
          if ($(this).is('.entry-header-3, .solutions-filter-wrapper')) {
            return true
          }
          return qsRegex ? $(this).find('.feed-solution-listing__title').text().match(qsRegex) : true
        },
      })
    }, 200)
  )
}
